import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { QUERY_KEYS } from 'core/query-client/query-keys.constants';
import { executeRequest } from 'core/utils/backend-service';
import { getDeviceTypes, getTests } from './reference-data.service';

export const useReferenceData = () => {
    const { data: deviceTypes = [], isLoading: deviceTypesLoading } = usePocQuery({
        queryKey: QUERY_KEYS.DEVICE_TYPES,
        queryFn: () => executeRequest(() => getDeviceTypes()),
    });
    const { data: tests = [], isLoading: testsLoading } = usePocQuery({
        queryKey: QUERY_KEYS.TESTS,
        queryFn: () => executeRequest(() => getTests()),
    });

    return {
        deviceTypes,
        tests,
        isLoading: deviceTypesLoading || testsLoading,
    };
};
